module.exports = __webpack_public_path__ + "static/media/banner-NRI.4a7e5372.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/banner-NRI.jpg
// module id = 1012
// module chunks = 0